<template>
  <div class="titleBar">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item, idx) in titleList" :key="idx">{{item}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: 'titleBar',
  data() {
    return {
      titleList: []
    }
  }, 
  created() {
    this.titleList = this.$route.meta.title
  },
  watch: {
    '$route': 'getMeta'
  },
  methods: {
    getMeta() {
      this.titleList = this.$route.meta.title
    }
  }
}
</script>
<style scoped>
.titleBar {
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
  padding: 12px 8px;
  height: 40px;
  line-height: 32px;
  width: 100%;
  box-sizing: border-box;
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/titleBar.vue